import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Devices = ({
  size,
  type,
  theme,
  className,
  dataTestId = "devices-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.988a1.88 1.88 0 0 1 1.88-1.88h10.024a1.88 1.88 0 0 1 1.88 1.88v.506h.634c.874 0 1.582.72 1.582 1.61v6.577c0 .89-.708 1.61-1.582 1.61h-3.402c-.848 0-1.54-.679-1.58-1.532h-.527l.376 1.88h.74a.627.627 0 0 1 0 1.253H3.759a.627.627 0 0 1 0-1.253h.74l.376-1.88H1.88A1.88 1.88 0 0 1 0 9.88V2.989Zm9.434 7.518V9.253h-8.18v.627c0 .346.28.626.626.626h7.554Zm0-2.506V5.104c0-.89.708-1.61 1.582-1.61h1.515v-.506a.627.627 0 0 0-.627-.627H1.88a.627.627 0 0 0-.627.627V8h8.181Zm-3.657 5.639.376-1.88H7.63l.376 1.88h-2.23Zm4.712-8.535c0-.297.236-.537.527-.537h.636c0 .301.245.546.546.546h1.038a.546.546 0 0 0 .546-.546h.636c.292 0 .528.24.528.537v6.577a.532.532 0 0 1-.528.537h-3.402a.532.532 0 0 1-.527-.537V5.104Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SVGIcon>
);
